import { ENV, REGION } from "../constants/envUrls";
import { EnvironmentTypes, RegionType, SiteDetailsType } from "../types/common";

export const getRuntimeVariables = (url: string) => {
  if (/local/.test(url)) {
    return "qa1";
  }

  const [env] = url.split(".") as string[];
  const runtimeVariables = (env === "www" ? "prod" : env || "qa1") as string;
  return runtimeVariables;
};

export const getSiteProps = (url?: string | null): SiteDetailsType | null => {
  try {
    if (url) {
      if (/local/.test(url)) {
        const info = (ENV as unknown as EnvironmentTypes).qa1.regions.india;
        return info;
      } else {
        const [env, ...rest] = url.split(".") as string[];
        const region = rest.join(".") as string;
        const envVar = (env === "www" ? "prod" : env || "qa1") as string;
        const envData = (ENV as unknown as EnvironmentTypes)[
          envVar as keyof EnvironmentTypes
        ];
        if (!envData) {
          throw new Error(
            `Environment variable ${envVar} is not defined in ENV`,
          );
        }

        const regionData =
          envData.regions[(REGION as RegionType)[region as keyof RegionType]];
        if (!regionData) {
          throw new Error(
            `Region ${region} is not defined in ENV for environment ${envVar}`,
          );
        }
        return regionData;
      }
    } else {
      return {
        api_url: "https://qa1.foundit.in",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monsterindia.com",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "rexmonster",
        host_domain: "qa1.foundit.in",
        domain: "foundit.in",
        media_url: "media.foundit.in",
        region: "india",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
        gtm_id: "GTM-NGL6ZM",
      };
    }
  } catch (e) {
    return {
      api_url: "https://qa1.foundit.in",
      api_t_1: "https://qa1.monsterindia.com",
      api_t_2: "https://qa1.monsterindia.com",
      api_t_3: "https://qa1.monsterindia.com",
      site_map: "rexmonster",
      host_domain: "qa1.foundit.in",
      domain: "foundit.in",
      media_url: "media.foundit.in",
      region: "india",
      country_code: "IN",
      country_isd_code: "91",
      country_id: "110",
      currency_code: "INR",
      currency_id: "4",
      currency_name: "Indian Rupees",
      currency_sign: "₹",
      gtm_id: "GTM-NGL6ZM",
    };
  }
};

export const getBuildEnvVar = (url?: string | null) => {
  try {
    if (!url || /local/.test(url)) {
      return "qa1";
    } else {
      const env = url.split(".")[0];
      return env === "www" ? "prod" : env;
    }
  } catch (e) {
    return "qa1";
  }
};

export const getImageEnvUrl = (url: string) => {
  const domain = window.location.hostname;
  const envBaseUrl = getSiteProps(domain)?.api_url;
  return `${envBaseUrl}${url}`;
};
